import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleNextIcon } from '@glu/icons-react';
import { hex } from 'wcag-contrast';

import BrandingContext from '../../BrandingContext';

const colorRatios = {
  aa: {
    normal: 4.5,
    large: 3
  },
  aaa: {
    normal: 7,
    large: 4.5
  }
};

const isLarge = ({ fontSize, fontWeight }) => (fontSize > 18.66 && (fontWeight === 'bold' || fontWeight >= 700)) || fontSize > 24;

const ContrastCheck = ({
  color, backgroundColor, fontSize, fontWeight, standard: standardProp
}) => {
  const { accessibilityStandard } = useContext(BrandingContext);
  const standard = accessibilityStandard || standardProp;
  const colorInfo = useMemo(() => {
    if (!backgroundColor || !color) {
      return null;
    }

    const standardRatios = colorRatios[standard];
    const targetRatio = standardRatios[isLarge({ fontSize, fontWeight }) ? 'large' : 'normal'];
    const ratio = Math.floor(hex(backgroundColor, color) * 100) / 100;

    return {
      passes: ratio >= targetRatio,
      standard,
      ratio,
      targetRatio
    };
  }, [backgroundColor, color, fontSize, fontWeight, standard]);


  if (!colorInfo || colorInfo.passes) {
    return null;
  }

  const link = `https://webaim.org/resources/contrastchecker/?fcolor=${color.replace('#', '')}&bcolor=${backgroundColor.replace('#', '')}`;

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <ExclamationCircleNextIcon />
    </a>
  );
};

ContrastCheck.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  standard: PropTypes.string
};

ContrastCheck.defaultProps = {
  color: null,
  backgroundColor: null,
  fontSize: null,
  fontWeight: null,
  standard: 'aa'
};

export default ContrastCheck;
